import { TITLES } from '@/src/constants/travelers'
import { Gender, PassengerType, Title } from '@/src/types/itinerary'

export const titleToGenderMap = (title: Title) => {
    switch (title) {
        case 'Mr':
        case 'Mstr':
            return 'Male'
        case 'Ms':
        case 'Mrs':
        case 'Miss':
            return 'Female'
        default:
            return ''
    }
}

export const genderToTitleMap = (gender: Gender, paxType: PassengerType) => {
    return TITLES[paxType].find(title => titleToGenderMap(title)?.toLowerCase() === gender?.toLowerCase()) || ''
}
